import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollProgress from "../components/ScrollProgress";
import BackToTop from "../components/BackToTop";
import { useLenis } from "../hooks/useLenis";
import { useReveal } from "../hooks/useReveal";
import useSEO from "../hooks/useSEO";
import { useLang } from "../contexts/LanguageContext";

const SORO_SCRIPT_SRC =
  "https://app.trysoro.com/api/embed/cb6859b1-4d59-4eb8-a3c4-e48f533f3a40";

const Blog = () => {
  const ref = useReveal();
  useLenis();
  const { lang } = useLang();

  useSEO({
    title: "Blog — EKOBIOTEK Ukraine | Sunflower oil news & insights",
    description:
      "News, market insights and craft stories from EKOBIOTEK — Ukrainian sunflower oil and vegetable oil producer.",
    canonical: "https://ekobiotek-ukraine.com.ua/blog",
    ogImage: "https://ekobiotek-ukraine.com.ua/ekobiotek-logo.jpg",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });

    // Inject Soro embed script once
    let script = document.querySelector(`script[src="${SORO_SCRIPT_SRC}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = SORO_SCRIPT_SRC;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      // Re-trigger if widget re-mounts
      const fresh = document.createElement("script");
      fresh.src = SORO_SCRIPT_SRC;
      fresh.defer = true;
      document.body.appendChild(fresh);
    }
  }, []);

  const subtitle = {
    en: "News, market insights and craft stories from our fields and presses.",
    fr: "Actualités, analyses du marché et récits depuis nos champs et nos pressoirs.",
    ua: "Новини, аналітика ринку та історії з наших полів і пресів.",
  }[lang];

  return (
    <div ref={ref} className="relative bg-[#FDFBF7] min-h-screen flex flex-col">
      <ScrollProgress />
      <Header />

      <section className="relative bg-[#1A201C] text-white pt-40 pb-20">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle, #DE9E36 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="divider-line" />
            <span className="overline text-[#DE9E36]">Blog</span>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.05]">
            Blog
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed">
            {subtitle}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20 flex-1">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div id="soro-blog" data-testid="soro-blog-embed" />
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default Blog;
